<template>
	<div class="consultAndReply" @click="handleClick">
    <div class="consult">
      <div class="left">
        <span class="subject">{{owner}}</span>
        <span class="action">提问</span>
        <span class="title">{{consult.title}}</span>
      </div>
      <div class="right">
        {{ date }}
      </div>
    </div>
    <div class="replys">
      <ReplyBox v-for="(item, index) in consult.replys" :reply="item" :title="consult.title"></ReplyBox>
    </div>
	</div>
</template>

<script>
import { getChatTime } from '@/utils/date'
import ReplyBox from '@/components/consult/replyBox.vue'
export default {
  name: 'ConsultBox',
  props: {
    consult: {},
    isMy: Boolean,
    index: Number,
  },
  components: {
    ReplyBox,
  },
  computed: {
    date() {
      return getChatTime(new Date(this.consult.createTime))
    },
    owner() {
      return this.isMy?'我':'有人'
    }
  },

  methods: {
    handleClick() {
        this.$emit('enterDetail',this.index, this.isMy)
    },
  }
}
</script>

<style lang="stylus" scoped>
.consult
  display: flex
  overflow: hidden
  background-color: #CDCDCD
  margin: 0.16rem 0
  padding: 0.12rem
  line-height :0.36rem
  .left
    flex:1
    float:left
    .subject
      color:#008DCF
      padding-right:0.12rem
    .action
      color:#999
      padding-right:0.12rem
    .title
      color:#008DCF
  .right
    margin-left:0.12rem
    float:right
    font-size :0.24rem
    color:#999
</style>
